export default "__VITE_ASSET__B8Z3gZ$C__"